import React from "react";
import DashboardContainer from "containers/jarivsPrime/Dashboard";
import { tracker } from "library/tracker";

const PrimeDashboard = () => {
    React.useEffect(() => {
        tracker.pageView();
    }, []);
    return (
        <>
            <DashboardContainer />
        </>
    );
};

export default PrimeDashboard;
